import {
  useMinimizedModalsContext,
  useNotification,
} from '../../../../../hooks'
import { resolveMinimizedDraftEntryOpen } from '../../../../Draft'
import { MINIMIZED_MODAL_KEY } from '../../../../Modal'
import {
  getListingEditMinimizedSourceId,
  RentalPortalListingsFormModal,
} from '../../RentalPortalListingsFormModal'
import { useRentalPortalListingFormOpener } from '../useRentalPortalListingFormOpener'

export function useEditRentalPortalListing({ setModal, onClose, onReload }) {
  const { handleAddSuccessNotification } = useNotification()

  const { getEntry } = useMinimizedModalsContext()

  const { openListingForm } = useRentalPortalListingFormOpener()

  function handleSuccess() {
    onClose()

    handleAddSuccessNotification('Notification.CommonTitleSavedKey')

    onReload?.()
  }

  function openModal(item, sourceId) {
    setModal(
      <RentalPortalListingsFormModal
        key={sourceId}
        listingId={item.id}
        onClose={onClose}
        onSuccess={handleSuccess}
      />
    )
  }

  function handleOpenEdit(item) {
    const sourceId = getListingEditMinimizedSourceId(item.id)

    function handleOpenForm() {
      openModal(item, sourceId)
    }

    function handleOpenResolved() {
      resolveMinimizedDraftEntryOpen({
        entry: getEntry(MINIMIZED_MODAL_KEY.RENTAL_PORTAL_LISTING_FORM),
        sourceId,
        onOpen: handleOpenForm,
      })
    }

    openListingForm({ sourceId, onOpen: handleOpenResolved })
  }

  return {
    handleOpenEdit,
  }
}
